<template>
  <AppLoadingContainer :predicate="!isLoaded">
    <form @submit.prevent="onSubmit()">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 col-lg-4 form-group">
            <label for="title">Title</label>
            <input class="form-control" v-model="visaInfo.titleDescription" disabled />
          </div>
          <div class="col-md-3 col-lg-4 form-group">
            <label for="emailAddress">Email Address</label>
            <input class="form-control" v-model="visaInfo.emailAddress" disabled />
          </div>
          <div class="col-md-3 col-lg-4 form-group">
            <label for="supervisor">Supervisor</label>
            <input
              class="form-control"
              v-model="visaInfo.supervisorName"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-sm-6 form-group">
            <label for="visaExpirationDate">VISA Expiration Date</label>
            <input
              class="form-control"
              :value="formattedVisaExpirationDate"
              disabled
            />
          </div>
          <div class="col-lg-2 col-sm-6 form-group">
            <label for="visaType">VISA Type</label>
            <input class="form-control" v-model="visaInfo.visaType" disabled />
          </div>
          <div class="col-lg-8 col-sm-12 form-group">
            <label for="citizenship">Citizen Status</label>
            <input
              class="form-control"
              v-model="visaInfo.citizenship"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-4 form-group">
            <label for="employeeType">Employee Type</label>
            <input
              class="form-control"
              v-model="visaInfo.employeeType"
              disabled
            />
          </div>
          <div class="col-md-2 form-group">
            <label for="isActive">Is Active</label>
            <b-form-checkbox
              v-model="visaInfo.isActive"
              disabled
            ></b-form-checkbox>
          </div>
          <div class="col-md-2 form-group">
            <label for="isActive">HR Is Processing</label>
            <b-form-checkbox
              v-model="visaInfo.hrProcessingVISA"
            ></b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-4 form-group">
            <label for="h1BStartDate">H-1B Start Date</label>
            <b-input-group class="mb-3">
              <b-form-input
                v-model="h1BStartDate"
                type="text"
                placeholder="MM/DD/YYYY"
                :disabled="true"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  v-model="visaInfo.h1BStartDate"
                  button-only
                  right
                  reset-button
                  locale="en-US"
                  aria-controls="h1BStartDate"
                  @context="updateH1BStartDateFromButton()"
                ></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
      </div>
      <div class="card-footer d-print-none text-right">
        <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
        <RouterLink :to="{ name: 'VISAs' }" class="btn btn-danger"
          >Back</RouterLink
        >
      </div>
    </form>
  </AppLoadingContainer>
</template>

<script>
import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
import PersonVisaService from "@/services/PersonVisaService";
import {ToastType} from "@/services/models/shared/ToastType";

export default {
  components: {
    AppLoadingContainer,
  },
  data() {
    return {
      visaInfo: {
        titleDescription: null,
        email: null,
        supervisorName: null,
        visaExpirationDate: null,
        visaType: null,
        citizenStatus: null,
        employeeType: null,
        isActive: false,
        hrProcessingVISA: false,
        h1BStartDate: null
      },
      h1BStartDate: null,
      isLoaded: false,
      isSubmitting: false
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedVisaExpirationDate() {
      if (this.visaInfo.visaExpirationDate) {
        return new Date(this.visaInfo.visaExpirationDate).toLocaleDateString();
      }
      return '-';
    },
  },
  methods: {
    fetchVisaDetails() {
      PersonVisaService.getPersonVisaInformation(this.id)
        .then((response) => {
          this.visaInfo = response;
          this.isLoaded = true;
        })
        .catch((error) => {
          this.$router.push({ name: "ErrorPage" });
        });
    },

    updateH1BStartDateFromButton () {
      if (this.visaInfo.h1BStartDate !== undefined && this.visaInfo.h1BStartDate !== null && this.visaInfo.h1BStartDate !== '') {
        this.h1BStartDate = this.$moment(this.visaInfo.h1BStartDate).format("MM/DD/YYYY");
      } else {
        this.visaInfo.h1BStartDate = null;
        this.h1BStartDate = null;
      }
    },

    onSubmit() {
      const vm = this;

      this.isSubmitting = true;
      PersonVisaService.updatePersonVisaInformation(vm.id, { hrProcessingVISA: this.visaInfo.hrProcessingVISA, h1BStartDate: this.h1BStartDate })
        .then(() => {
            vm.alert(ToastType.Success, "The person's VISA information was successfully updated")
        }).catch(error => {
          vm.alert(ToastType.Danger, error.response.statusText)
        }).finally(() => {
            vm.isSubmitting = false
        });
    }
  },
  created() {
    this.fetchVisaDetails();
  },
};
</script>
